/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI76162ResDataItem {
  
  /** 成员id */
  userId?: string;
  
  /** 成员名称 */
  userName?: string;
  
  /** 成员头像 */
  userHeadUrl?: string;
  
  /** 成员真实名称 */
  realName?: string;
  
  /** 是否逾期0-否1-是 */
  isOverdue?: number;
  
};
    
  



export interface API76162Req {
  
  /** 聊天室ID(String) */
  roomId?: string;
    
};



export type API76162Res = IAPI76162ResDataItem[];


// 接口函数 76162 获取聊天室成员列表

export interface IUseGetAPI76162Return {
  /** 获取聊天室成员列表: 接口请求状态 */
  isAPI76162Loading: boolean;
  /** 获取聊天室成员列表: 接口请求返回数据 */
  dataAPI76162: API76162Res;
  /**  获取聊天室成员列表: 接口数据请求方法 */
  fetchAPI76162Data: (inputs: API76162Req, config?: YWRequestConfig) => Promise<API76162Res>;
  /** 获取聊天室成员列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76162 = ():IUseGetAPI76162Return => {
  let isMount = true;
  const [isAPI76162Loading, setIsAPI76162Loading] = useState(false);
  const [dataAPI76162, setDataAPI76162] = useState<API76162Res>({} as API76162Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/room/member/list`;

  const fetchAPI76162Data = async (inputs: API76162Req, config?: YWRequestConfig): Promise<API76162Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76162Req>) || {}) as API76162Req;
    
  
    if ( isMount ) {
      setIsAPI76162Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API76162Res>(`${basePath}/yoaichat-web/chat/room/member/list?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI76162(res || {} as API76162Res);
        setIsAPI76162Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76162Loading(false);
      }
      return false as unknown as API76162Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76162Loading,
    dataAPI76162,
    fetchAPI76162Data,
    requestUrl,
  }
}

